import { render, staticRenderFns } from "./serving_size.vue?vue&type=template&id=3ed79f45&scoped=true&"
import script from "./serving_size.vue?vue&type=script&lang=js&"
export * from "./serving_size.vue?vue&type=script&lang=js&"
import style0 from "./serving_size.vue?vue&type=style&index=0&id=3ed79f45&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed79f45",
  null
  
)

export default component.exports